/**
 * App version, as rendered by the server into `<body data-app-version>`
 * (`Romantic\Data\Version::get()`).
 *
 * The sibling attribute `data-app-release` — the Sentry release, composed by PHP
 * (`Romantic\Tool\Sentry\Release`) — deliberately has NO helper here: its only
 * consumer is the `Sentry.init` call in `assets/js/general.js`, which is legacy
 * vanilla outside the module bundle and reads the dataset directly. An exported
 * reader with no caller is dead code.
 *
 * The version is a separate attribute rather than something parsed back out of
 * the release, and is never derived from it: a `SENTRY_RELEASE` override
 * replaces the release with an opaque string while PHP keeps tagging
 * `app.version` from `composer.json`, so parsing would report a value the
 * backend never reports for that deploy.
 */

const VERSION_ATTRIBUTE = 'appVersion';

/** Bare semver, e.g. `0.2.1`; null on a page rendered before this shipped. */
export function getAppVersion(): string | null {
    const value = document.body?.dataset?.[VERSION_ATTRIBUTE];

    return value ? value : null;
}
